const navLinkStyledSignUp = {
  text: 'Já tem uma conta? Sign in'
};

export default navLinkStyledSignUp;
